import { createAppI18n } from '@repo/ui/i18n/create-app-i18n';

export default createAppI18n({ debug: import.meta.env.DEV });
